export default {
  pa: "invalid_api_key",
  Ra: "blacklisted",
  ba: "no_device_identifier",
  ma: "invalid_json_response",
  fa: "empty_response",
  __: "sdk_auth_error"
};
